import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import { boolean } from '../DataGrid/formatters';
import translations from './translations';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const FULFILMENT_APP_ORIGIN = BASE_URL.replace('{app}', 'fulfilment');

const ShipmentListItem = ({ shipment }) => {
  const intl = useIntl();
  const isSameOrigin = window.location.origin === FULFILMENT_APP_ORIGIN;

  return (
    <>
      <Divider />
      <ListItem
        button
        {...(isSameOrigin
          ? { component: Link, to: `/shipments/${shipment?.id}` }
          : { component: 'a', href: `${FULFILMENT_APP_ORIGIN}/shipments/${shipment?.id}` })}
      >
        <Box flex={1} py={1}>
          <Box display="flex" justifyContent="space-between" alignItems="baseline" mb={1}>
            <Typography variant="subtitle1" color="primary">
              {shipment?.number ?? 'Concept'}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {formatDateTime(shipment?.created_at)}
            </Typography>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography variant="overline" color="textSecondary">
                {intl.formatMessage(translations.properties.expectedAt)}
              </Typography>
              <Typography variant="body2">{formatDateTime(shipment?.expected_at)}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="overline" color="textSecondary">
                {intl.formatMessage(translations.properties.outbound)}
              </Typography>
              <Typography variant="body2">{boolean(shipment?.is_outbound)}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="overline" color="textSecondary">
                {intl.formatMessage(translations.properties.isFinished)}
              </Typography>
              <Typography variant="body2">{boolean(shipment?.is_finished)}</Typography>
            </Grid>
          </Grid>
        </Box>
      </ListItem>
    </>
  );
};

ShipmentListItem.propTypes = {
  shipment: PropTypes.object,
};

ShipmentListItem.defaultProps = {
  shipment: null,
};

export default ShipmentListItem;
